import { Button, Card, Slider, Switch } from "antd";
import CheckedIcon from "../../../assets/web/icons/CheckedIcon";
import UnCheckedIcon from "../../../assets/web/icons/UnCheckedIcon";

interface PricingCardProps {
  title: string;
  price: number;
  duration?: string;
  employees?: number;
  features: {
    label: string;
    checked: boolean;
  }[];
  isCustomizable?: boolean;
  buttonPrimary: boolean;
  borderColor: string;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  duration = "/Yearly",
  employees,
  features,
  buttonPrimary,
  isCustomizable = false,
  borderColor,
}) => {
  return (
    <Card
      className={`shadow-xl shadow-slate-100 border-t-2 border-t-[${borderColor}] p-2 border text-[#2D3643]`}
    >
      <h3 className="text-lg font-semibold text-[24px]">{title}</h3>
      <p className="font-bold mb-6 mt-4">
        ৳<span className="text-4xl">{price}</span>{" "}
        <span className="text-gray-500 text-sm">{duration}</span>
      </p>

      {buttonPrimary ? (
        <Button type="primary" className="w-full mt-4">
          Select Plan
        </Button>
      ) : (
        <Button className="w-full mt-4 text-webPrimary border-webPrimary">
          Select Plan
        </Button>
      )}

      {isCustomizable && employees !== undefined && (
        <div className="mt-4">
          <div className="flex justify-between">
            <p className="text-sm">For {employees} Employees</p>
            <Switch className="ml-2" defaultChecked />
          </div>
          <Slider
            defaultValue={employees}
            max={100}
            step={1}
            className="mt-2"
          />
        </div>
      )}

      <ul className="mt-4 space-y-2">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center text-sm">
            <span className="mr-2">
              {feature.checked ? <CheckedIcon /> : <UnCheckedIcon />}
            </span>
            <span>{feature.label}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
};

export default PricingCard;
